import React from 'react';

/**
 * PublicPageRedirect Component
 * Ensures public pages are accessible on the correct domain (platform-public)
 * Public pages should be accessible to everyone (authenticated and unauthenticated)
 * 
 * If accessed from platform-auth domain, this component ensures the page is still accessible
 * (no redirect needed - public pages can be viewed by authenticated users too)
 */
const PublicPageRedirect = ({ children }) => {
  // Public pages are accessible to everyone - no redirect needed
  // The Footer component handles domain-aware linking, so if someone clicks
  // a Footer link from platform-auth, it will go to platform-public domain
  // But if they're already here, they should be able to view the page
  
  // Just render children - public pages are for everyone
  return <>{children}</>;
};

export default PublicPageRedirect;

